module.exports = __webpack_public_path__ + "img/btnCard-4.efea78e0.jpg";